import axios from 'axios'
import { createWithEqualityFn } from 'zustand/traditional'
import { CRUDBaseStore } from './Base/CRUD'
import { cleanParamsFilter } from 'Utils/cleanParamsFilter'

interface ContractStore extends Partial<CRUDBaseStore> {
	data: any[]
	selected: any
	stat: any
	summary: any
	setSelected: (selected: any) => void
	getAll: (filter: any) => Promise<{ success: boolean; data: any }>
	getOne: (uuId: string) => Promise<{ success: boolean; data: any }>
	getStat: () => Promise<{ success: boolean; data: any }>
	getSummaryStat: () => Promise<{ success: boolean; data: any }>
	deliverSample: (uuId: string, data: any) => Promise<{ success: boolean; data: any }>
	deliverProduct: (uuId: string, data: any) => Promise<{ success: boolean; data: any }>
	clearState: () => void
}

export const API_SLUG = '/supplier-contracts'

export const useContractStore = createWithEqualityFn<ContractStore>(
	set => ({
		data: [],
		selected: {},
		stat: {},
		summary: {},
		setSelected: (selected: any) => set({ selected }),
		getAll: async filter => {
			return axios
				.get(`${API_SLUG}`, {
					params: cleanParamsFilter(filter),
				})
				.then(res => {
					set({ data: res.data })
					return { success: true, data: res.data }
				})
				.catch(err => {
					return { success: false, data: err?.response?.data?.message?.toString() }
				})
		},
		getOne: async (uuId: string) => {
			return axios
				.get(`${API_SLUG}/${uuId}`)
				.then(res => {
					set({ selected: res.data })
					return { success: true, data: res.data }
				})
				.catch(err => {
					return { success: false, data: err?.response?.data?.message?.toString() }
				})
		},
		getStat: async () => {
			return axios
				.get(`/suppliers/contract-stat`)
				.then(res => {
					set({ stat: res.data })
					return { success: true, data: res.data }
				})
				.catch(err => {
					return { success: false, data: err?.response?.data?.message?.toString() }
				})
		},
		getSummaryStat: async () => {
			return axios
				.get(`/suppliers/contract-summary`)
				.then(res => {
					set({ summary: res.data })
					return { success: true, data: res.data }
				})
				.catch(err => {
					return { success: false, data: err?.response?.data?.message?.toString() }
				})
		},
		deliverSample: async (uuId: string, data: any) => {
			const formData = new FormData()
			formData.append('sentSampleTracking', data.sentSampleTracking)
			formData.append('sentSampleEvidencePicture', data.sentSampleEvidencePicture)

			return axios
				.post(`${API_SLUG}/${uuId}/delivery-sample`, formData)
				.then(res => {
					return { success: true, data: res.data }
				})
				.catch(err => {
					return { success: false, data: err?.response?.data?.message?.toString() }
				})
		},
		deliverProduct: async (uuId: string, data: any) => {
			const formData = new FormData()
			formData.append('sentProductsTracking', data.sentProductsTracking)
			formData.append('sentProductsEvidencePicture', data.sentProductsEvidencePicture)

			return axios
				.post(`${API_SLUG}/${uuId}/delivery-products`, formData)
				.then(res => {
					return { success: true, data: res.data }
				})
				.catch(err => {
					return { success: false, data: err?.response?.data?.message?.toString() }
				})
		},
		clearState: () => set({ data: [], stat: {}, selected: {} }),
	}),
	Object.is
)
